import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { NotificationsService } from './notifications.service';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    private apiUrl = environment.backendUrlPort;
    allUsers: any;
    constructor(
        private http: HttpClient,
        private notification: NotificationsService,
        private authService: AuthService
    ) {}

    getStaticFolderImages() {
        let Api: string =
            environment.backendUrlPort + '/assets/profile_photos/';
        return Api;
    }

    getLocalStorage() {
        return new HttpHeaders({
            Authorization:
                'Bearer ' + JSON.parse(localStorage.getItem('user')).token,
        });
    }

    getIntroduction(userId: number) {
        let Api: string = this.apiUrl + '/users/getUserIntroduction/' + userId;
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    postIntroduction(body: any) {
        let Api: string = this.apiUrl + '/users/editUserIntroduction/';
        return this.http.post<any>(Api, body, {
            headers: this.getLocalStorage(),
        });
    }

    get_all_network_connections(index, myFilter): Observable<any> {
        let Api: string = this.apiUrl + '/social/getAllNetworkConnections/';
        return this.http.post<any>(Api, myFilter, {
            headers: this.getLocalStorage(),
        });
    }

    get_all_user_info(index): Observable<any> {
        let Api: string = this.apiUrl + '/users/getUserBasicInfo/' + index;
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    get_user_social(index): Observable<any> {
        let Api: string = this.apiUrl + '/users/getUserSocial/' + index;
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    delete_user_friend(index): Observable<any> {
        let Api: string = this.apiUrl + '/social/deleteFriend/' + index;
        return this.http.delete<any>(Api, { headers: this.getLocalStorage() });
    }

    add_user_friend(index): Observable<any> {
        let Api: string = this.apiUrl + '/social/sendFriendRequest/' + index;
        return this.http.post<any>(
            Api,
            {},
            { headers: this.getLocalStorage() }
        );
    }

    cancel_user_friend(index): Observable<any> {
        let Api: string = this.apiUrl + '/social/deleteFriendRequest/' + index;
        return this.http.delete<any>(Api, { headers: this.getLocalStorage() });
    }

    accept_user_friend(index): Observable<any> {
        let Api: string = this.apiUrl + '/social/acceptFriendRequest/' + index;
        return this.http.put<any>(Api, { headers: this.getLocalStorage() });
    }

    get_all_users(): Observable<any> {
        let Api: string = this.apiUrl + '/users/getAllUsers/';
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    get_all_friends(): Observable<any> {
        let Api: string = this.apiUrl + '/users/getFriends/';
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    getAllUsersJoined(): Observable<any> {
        let Api: string = this.apiUrl + '/users/getAllUsersJoined/';
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    get_all_users_by_page(myFilter): Observable<any> {
        let Api: string = this.apiUrl + '/users/getAllUsersByPage/';
        return this.http.post<any>(Api, myFilter, {
            headers: this.getLocalStorage(),
        });
    }

    get_all_pendings_requests(): Observable<any> {
        let Api: string = this.apiUrl + '/social/getAllPendingFriendRequests/';
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    get_all_send_requests(): Observable<any> {
        let Api: string = this.apiUrl + '/social/getAllSentFriendRequests/';
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    get_all_users_friends(): Observable<any> {
        let Api: string = this.apiUrl + '/social/getAllNetworkConnectionIDs/';
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    submit_profile_infos(data: any, index): Observable<any> {
        let Api: string = this.apiUrl + '/users/editUser/' + index;
        return this.http.put<any>(Api, data, {
            headers: this.getLocalStorage(),
        });
    }
    ////////////////////////// RESPONSE my friends sevices /////////////////
    addFriend(userId: any, data: any): Observable<any> {
        let Api: string = this.apiUrl + '/users/userAddFriend/' + userId;
        return this.http.put<any>(Api, data, {
            headers: this.getLocalStorage(),
        });
    }

    removeFriend(userId: any, data: any): Observable<any> {
        let Api: string = this.apiUrl + '/users/userRemoveFriend/' + userId;
        return this.http.put<any>(Api, data, {
            headers: this.getLocalStorage(),
        });
    }

    //////////////////////// notifications /////////////////////////////
    submit_notifications(data: any, type: string): Observable<any> {
        let Api: string = this.apiUrl + '/users/notifications?type=' + type;
        return this.http.post<any>(Api, data, {
            headers: this.getLocalStorage(),
        });
    }

    submit_notificationsCompJoin(data: any, type: string): Observable<any> {
        let Api: string =
            this.apiUrl + '/users/notificationsCompJoin?type=' + type;
        return this.http.post<any>(Api, data, {
            headers: this.getLocalStorage(),
        });
    }

    submit_notificationsContacts(data: any, type: string): Observable<any> {
        let Api: string =
            this.apiUrl + '/users/notificationsContacts?type=' + type;
        return this.http.post<any>(Api, data, {
            headers: this.getLocalStorage(),
        });
    }

    ////////////////////////// notifications end //////////////////////////////////////

    public uploadImage(image: File, index): Observable<any> {
        const formData = new FormData();
        formData.append('image', image);
        let Api: string = this.apiUrl + '/users/saveUserProfilePhoto/';
        return this.http.post(Api, formData, {
            headers: this.getLocalStorage(),
        });
    }

    public getUserImage(userId: number): Observable<any> {
        let Api: string = this.apiUrl + '/users/getUserProfilePhoto/' + userId;
        return this.http.get<any>(Api, { headers: this.getLocalStorage() });
    }

    //////////////////////// service for network to add into users data a flag "hide" used for the add friend button ///////////////////
    get_all_friends_for_network(): Observable<any> {
        var userId = this.authService.getLocalStorage('user').id;
        return forkJoin([
            this.notification.getAllNotificationsContacts(
                'notifications_contacts'
            ),
            this.get_all_users(),
            this.getNetworkMatchmaking(userId),
        ]).pipe(
            map(([allNotif, allUsers, userSimilarity]) => {
                for (let i = 0; i < allUsers.length; i++) {
                    var hideAddButton = 'false'; // Initialize to false
                    // console.log(allUsers[i].friends)
                    var allUserFriends = JSON.parse(allUsers[i].friends);
                    var isFriend = allUserFriends.map(Number).includes(userId);
                    // console.log(allUsers[i].userId)
                    allNotif.forEach((el) => {
                        if (
                            ((allUsers[i].userId == el.receiverId &&
                                userId == el.senderId) ||
                                (allUsers[i].userId == el.senderId &&
                                    userId == el.receiverId)) &&
                            (el.connected !== 'declined' || isFriend) &&
                            el.type == 'addContact'
                        ) {
                            hideAddButton = 'true';
                        }
                        if (
                            ((allUsers[i].userId == el.receiverId &&
                                userId == el.senderId) ||
                                (allUsers[i].userId == el.senderId &&
                                    userId == el.receiverId)) &&
                            el.connected == 'accepted' &&
                            !isFriend &&
                            el.type == 'addContact'
                        ) {
                            hideAddButton = 'false';
                        }
                    });

                    // Pass the network matchmaking data inside the allUsers object
                    const userID = allUsers[i].userId;
                    const similarityData = userSimilarity.filter((data) => {
                        return data.user1 == userID || data.user2 == userID;
                    })[0];
                    allUsers[i]['areaOfStudiesSimilarity'] =
                        similarityData.areaOfStudiesSimilarity;
                    allUsers[i]['fieldOfWorkSimilarity'] =
                        similarityData.fieldOfWorkSimilarity;
                    allUsers[i]['sectorsOfInterestSimilarity'] =
                        similarityData.sectorsOfInterestSimilarity;
                    allUsers[i].hide = hideAddButton;
                }
                return allUsers;
            })
        );
    }

    getUsersSimilarity(user1: string, user2: string): Observable<any> {
        return this.http.get(
            `${this.apiUrl}/usersSimilarity?user1=${user1}&user2=${user2}`
        );
    }

    getNetworkMatchmaking(userID: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/userSimilarity?userID=${userID}}`);
    }
}
